export default function setUpFreshworksWidget(viewer, largeMedia) {
  window.FreshworksWidget('show');
  window.FreshworksWidget('disable', 'ticketForm', [
    'name',
    'email',
    'custom_fields.cf_environment',
  ]);
  window.FreshworksWidget('hide', 'ticketForm', [
    'custom_fields.cf_current_role',
    'custom_fields.cf_device_category',
    'custom_fields.cf_ip_address',
    'custom_fields.cf_current_url',
  ]);
  window.FreshworksWidget('identify', 'ticketForm', {
    email: viewer?.email,
    name: viewer?.name,
    custom_fields: {
      cf_environment: process.env.REACT_APP_WIDGET_ENVIRONMENT,
      cf_current_url: window.location.href,
      cf_current_role: viewer?.currentRole?.role?.name,
      // cf_ip_address: '10.20.0.110',
      cf_device_category: largeMedia ? 'Desktop' : 'Tablet',
    },
  });
}
